export const FETCH_WFH_LOADING = 'FETCH_WFH_LOADING';
export const FETCH_WFH_SUCCESS = 'FETCH_WFH_SUCCESS';
export const FETCH_WFH_ERROR = 'FETCH_WFH_ERROR';

export const DELETE_WFH_LOADING = 'DELETE_WFH_LOADING';
export const DELETE_WFH_SUCCESS = 'DELETE_WFH_SUCCESS';
export const DELETE_WFH_ERROR = 'DELETE_WFH_ERROR';

export const FETCH_WFH_OPERATIONS_LOADING = 'FETCH_WFH_OPERATIONS_LOADING';
export const FETCH_WFH_OPERATIONS_SUCCESS = 'FETCH_WFH_OPERATIONS_SUCCESS';
export const FETCH_WFH_OPERATIONS_ERROR = 'FETCH_WFH_OPERATIONS_ERROR';
